import react, { useEffect } from "react"
import "./admin.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSession, selectAdminToken, selectSessionId, selectOrganizationId } from "./sessionSlice";
import AdminTour from "./tour/AdminTour";
import AdminNav from "./components/AdminNav";

function Admin({children}){
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const adminToken = useSelector(selectAdminToken);
  const currentSessionId = useSelector(selectSessionId);
  const currentOrganizationId = useSelector(selectOrganizationId);

  // Regular admins arrive with ?sessionId=&organizationId= (AdminRedirect).
  const searchParams = new URLSearchParams(location.search);
  const sessionIdFromUrl = searchParams.get('sessionId');
  const organizationIdFromUrl = searchParams.get('organizationId');
  const hasUrlSession = Boolean(sessionIdFromUrl && organizationIdFromUrl);
  // Hold children until Redux carries the URL session, otherwise child effects
  // (they run before ours) fetch with a stale/superadmin token.
  const urlSessionPending = hasUrlSession &&
    (currentSessionId !== sessionIdFromUrl || currentOrganizationId !== organizationIdFromUrl);

  useEffect(() => {
    if (urlSessionPending) {
      dispatch(setSession({ sessionId: sessionIdFromUrl, organizationId: organizationIdFromUrl }));
    }
  }, [urlSessionPending, sessionIdFromUrl, organizationIdFromUrl, dispatch]);

 const raw = location.pathname;
 const cleaned = raw.endsWith("/") && raw !== "/" ? raw.slice(0, -1) : raw;
 const isRootAdmin = cleaned === "/admin";
 const isSuperAdmin = adminToken === 'admin&admin';

 // No admin session at all: superadmin must log in explicitly; regular
 // admins only get here via /login?admin=true or AdminRedirect.
 if (!adminToken && !hasUrlSession) {
   return <Navigate to="/admin/superadmin" replace />;
 }

      const redirectGameSession = () => {
        try {
          const stored =
            sessionStorage.getItem("userData") || localStorage.getItem("userData");
          if (!stored) return;
          const parsed = JSON.parse(stored);
          const gameId = parsed?.gameId;
          if (!gameId) return;
          window.location.href = `${process.env.REACT_APP_BASE_URL}/active-games/${gameId}`;
        } catch {
          /* ignore bad storage */
        }
      };

      return <div className="admin-background">
       <div className="header-admin">
        {/* {!isRootAdmin && (
          <div className="back-button-holder">
              <button
                className="back-button"
                onClick={() => navigate(-1)}
              >
              <i className="fa-solid fa-arrow-left"></i> Back
              </button>
          </div>
        )} */}

         <div className="brand-logo-and-game-holder">
          <div className="brand-logo-holder" onClick={()=>{window.location.href = process.env.REACT_APP_BASE_URL;}}>
          <img src="/admin/play.png" className="brand-logo"/>{isSuperAdmin && " SUPERADMIN"}
         </div>
         <div onClick={()=>{redirectGameSession()}}>Crossroads </div>
          
         </div>
       
         
         <div className="user">
            <img src="/admin/user.png"/>
         </div>
       </div>
       {urlSessionPending ? null : (
         <>
           {!isRootAdmin && <AdminNav />}
           {children}
           <AdminTour />
         </>
       )}
      </div>
}

export default Admin;
